module.exports = __webpack_public_path__ + "static/why-back-c1810ad1f9437bb843a1cee30f8128a4.jpg";